/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum AutoCompleteType {
    Unknown = 'Unknown',
    Station = 'Station',
    Location = 'Location',
    Country = 'Country',
    Region = 'Region'
}

export function AutoCompleteTypeFromJSON(json: any): AutoCompleteType {
    return AutoCompleteTypeFromJSONTyped(json, false);
}

export function AutoCompleteTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AutoCompleteType {
    return json as AutoCompleteType;
}

export function AutoCompleteTypeToJSON(value?: AutoCompleteType | null): any {
    return value as any;
}

